import { createSlice, PayloadAction } from "@reduxjs/toolkit";


// 初始狀態，包括從本地儲存獲取的儀表板設置
interface managementSlice {
  teamPlusNotify:boolean;
  chatWorkNotify:boolean;
}
const initialState: managementSlice = {
  // 從本地儲存獲取儀表板設置
  teamPlusNotify:false,
  chatWorkNotify:false
};
// 創建儀表板切片
const managementSlice = createSlice({
  name: "management",
  initialState,
  reducers: {
    setTeamPlusNotify: (state, action: PayloadAction<boolean>) => {
      state.teamPlusNotify = action.payload;
    },
    setChatWorkNotify: (state, action: PayloadAction<boolean>) => {
      state.chatWorkNotify = action.payload;
    }
  },
});
// 匯出動作創建函數

export const { setTeamPlusNotify,setChatWorkNotify} = managementSlice.actions;

// 匯出儀表板切片

export default managementSlice;
